var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0Z",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0296 7.09662C13.3225 6.80373 13.7974 6.80373 14.0903 7.09662C14.3565 7.36289 14.3807 7.77955 14.1629 8.07316L14.0903 8.15728L9.34427 12.9033C9.07804 13.1695 8.66146 13.1938 8.36784 12.976L8.28372 12.9034L5.90972 10.5304C5.61677 10.2376 5.61667 9.76269 5.9095 9.46973C6.17571 9.20341 6.59237 9.17912 6.88603 9.39691L6.97016 9.46951L8.81304 11.3118L13.0296 7.09662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.535decf1352007b2af2c8ee6c15ca7e5.svg";
export { ForwardRef as ReactComponent };